// Beschilderung: HTML für den Server-Druck (Puppeteer/Chromium auf Linux).
//
// WICHTIG: Auf dem Server gibt es keine Emoji-Schrift – Emojis werden dort als
// leere Kästchen gedruckt. Deshalb sind alle Symbole hier als eingebettete SVG
// gezeichnet (Material-Design-Pfade, Apache-2.0), die sind schriftunabhängig.
// Die Seitengeometrie ist exakt A4 quer OHNE Druckrand (siehe generate-signage-pdf),
// sonst läuft jede Seite über und erzeugt eine Leerseite.

import { AGB_DEFAULT } from './agbText';

const esc = (s) => String(s == null ? '' : s)
  .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// Text mit Zeilenumbrüchen → Absätze (leere Zeile = Abstand)
const paras = (text, cls) => String(text || '')
  .split('\n')
  .map((l) => l.trim() === '' ? '<div class="gap"></div>' : `<div class="${cls}">${esc(l)}</div>`)
  .join('');

const svg = (inner, viewBox = '0 0 24 24') =>
  `<svg class="ico" viewBox="${viewBox}" xmlns="http://www.w3.org/2000/svg">${inner}</svg>`;

const ICONS = {
  // Fahrrad (Material "pedal_bike") + rotes Verbotszeichen
  bike_forbidden: svg(
    '<circle cx="12" cy="12" r="11.2" fill="none" stroke="#d62828" stroke-width="1.6"/>' +
    '<g transform="translate(1.6 2.4) scale(0.87)"><path fill="#111" d="M18.18 10l-1.7-4.68C16.19 4.53 15.44 4 14.6 4H12v2h2.6l1.46 4h-4.81l-.36-1H12V7H7v2h1.75l1.82 5H9.9c-.44-2.23-2.31-3.88-4.65-3.99C2.45 9.87 0 12.2 0 15c0 2.8 2.2 5 5 5 2.46 0 4.45-1.69 4.9-4h4.2c.44 2.23 2.31 3.88 4.65 3.99 2.8.13 5.25-2.19 5.25-5 0-2.8-2.2-5-5-5h-.82zM7.82 16c-.4 1.17-1.49 2-2.82 2-1.68 0-3-1.32-3-3s1.32-3 3-3c1.33 0 2.42.83 2.82 2H5v2h2.82zm6.28-2h-1.4l-.73-2H15c-.44.58-.76 1.25-.9 2zm4.9 4c-1.68 0-3-1.32-3-3 0-.93.41-1.73 1.05-2.28l.96 2.64 1.88-.68-.97-2.67c.03 0 .06-.01.09-.01 1.68 0 3 1.32 3 3s-1.33 3-3.01 3z"/></g>' +
    '<line x1="4.2" y1="4.2" x2="19.8" y2="19.8" stroke="#d62828" stroke-width="1.6" stroke-linecap="round"/>'
  ),
  // Telefonhörer (Material "call")
  phone: svg('<path fill="#111" d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>'),
  // Koffer (Material "luggage")
  luggage: svg('<path fill="#111" d="M17 6h-2V3c0-.55-.45-1-1-1h-4c-.55 0-1 .45-1 1v3H7c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2 0 .55.45 1 1 1s1-.45 1-1h6c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM9.5 18H8V9h1.5v9zm3.25 0h-1.5V9h1.5v9zM13 6h-2V3.5h2V6zm3 12h-1.5V9H16v9z"/>'),
  // Kinderwagen (Material "child_friendly") + Regentropfen
  stroller_rain: svg(
    '<g transform="translate(2 4) scale(0.85)"><path fill="#111" d="M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 13.38 21 12H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 21.43 6.07 23 8 23c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 21c-.83 0-1.5-.67-1.5-1.5S7.17 18 8 18s1.5.67 1.5 1.5S8.83 21 8 21zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 18 17 18s1.5.67 1.5 1.5S17.83 21 17 21z"/></g>' +
    '<g fill="#2a7de1"><path d="M4 1.2c-1 1.6-1.6 2.4-1.6 3.1a1.6 1.6 0 0 0 3.2 0c0-.7-.6-1.5-1.6-3.1z"/><path d="M9 0.2c-1 1.6-1.6 2.4-1.6 3.1a1.6 1.6 0 0 0 3.2 0c0-.7-.6-1.5-1.6-3.1z"/><path d="M20 3.2c-1 1.6-1.6 2.4-1.6 3.1a1.6 1.6 0 0 0 3.2 0c0-.7-.6-1.5-1.6-3.1z"/></g>'
  ),
  // Uhr 00:30
  clock: svg(
    '<circle cx="12" cy="12" r="10.5" fill="none" stroke="#111" stroke-width="1.8"/>' +
    '<g stroke="#111" stroke-width="1.2" stroke-linecap="round">' +
    '<line x1="12" y1="2.6" x2="12" y2="4.2"/><line x1="12" y1="19.8" x2="12" y2="21.4"/>' +
    '<line x1="2.6" y1="12" x2="4.2" y2="12"/><line x1="19.8" y1="12" x2="21.4" y2="12"/></g>' +
    '<line x1="12" y1="12" x2="12" y2="5.2" stroke="#111" stroke-width="2" stroke-linecap="round"/>' +
    '<line x1="12" y1="12" x2="12" y2="19" stroke="#d62828" stroke-width="1.6" stroke-linecap="round"/>' +
    '<circle cx="12" cy="12" r="1.1" fill="#111"/>'
  ),
  // Waage (Haftung)
  scales: svg('<path fill="#111" d="M12 3a1.5 1.5 0 0 1 1.5 1.5c0 .5-.25.94-.63 1.2L18 6.5l3.4 7.2h-.02C21.7 15.7 20 17 18 17s-3.7-1.3-3.38-3.3H14.6L18 6.9l-5.25-.7v13.3H16V21H8v-1.5h3.25V6.2L6 6.9l3.4 6.8h-.02C9.7 15.7 8 17 6 17s-3.7-1.3-3.38-3.3H2.6L6 6.5l5.13-.8A1.5 1.5 0 0 1 12 3zm6 6.2-2.15 4.5h4.3L18 9.2zm-12 0-2.15 4.5h4.3L6 9.2z"/>'),
  // Pfeil (wird per CSS gedreht)
  arrow: svg('<path fill="#111" d="M12 2 4 10h5v12h6V10h5z"/>'),
};

const ARROW_ROT = { up: 0, right: 90, down: 180, left: 270 };

// Feste Inhalte je Schildtyp (der Editor kann title/content überschreiben)
export const SIGN_DEFAULTS = {
  no_bike_parking: {
    title: 'FAHRRAD ABSTELLEN VERBOTEN',
    content: 'Das Abstellen von Fahrrädern ist hier nicht gestattet.\nFahrräder werden kostenpflichtig entfernt.',
  },
  closed_emergency: {
    title: 'WIR HABEN GESCHLOSSEN',
    content: 'Sie erreichen unseren Notdienst unter:\nTel. 0176 43831566\n\nWE ARE CLOSED\nYou can reach our emergency service at:\nTel. +49 176 43831566',
  },
  closed_baggage: {
    title: 'WIR HABEN GESCHLOSSEN',
    content: 'Ihr Gepäckstück befindet sich nicht mehr auf der Station.\n\nWir sind morgen ab 9 Uhr wieder für Sie geöffnet.',
  },
  pram_warning: {
    title: 'ACHTUNG: KINDERWAGEN IM FREIEN',
    content: 'Kinderwagen werden im Außenbereich abgestellt.\n\nBitte bringen Sie Abdeckungen mit.\n\nKeine Haftung für Schäden.',
  },
  fire_hydrant: { title: '', content: '' },
  price_5euro: { title: 'Alle Gepäckstücke / Kinderwagen', content: '5€\npro Tag' },
  baggage_dropoff: { title: '↓ DROP-OFF ↓\n\nGEPÄCKANNAHME', content: 'Bitte geben Sie Ihr Gepäck hier ab.' },
  baggage_pickup: { title: '↓ PICK-UP ↓\n\nGEPÄCKABHOLUNG', content: 'Bitte holen Sie Ihr Gepäck hier ab.' },
  closing_time: {
    title: 'WE CLOSE AT 00:30 UHR',
    content: 'Bitte holen Sie Ihr Gepäck rechtzeitig ab.\n\nVielen Dank für Ihr Verständnis.',
  },
  liability_limit: { title: '', content: 'Haftungsobergrenze\n100€' },
};

const ICON_FOR = {
  no_bike_parking: 'bike_forbidden',
  closed_emergency: 'phone',
  closed_baggage: 'luggage',
  pram_warning: 'stroller_rain',
  closing_time: 'clock',
};

const FOOT = '<div class="foot">gepaeckannahme.de</div>';

function renderSign(sign) {
  const d = { ...(SIGN_DEFAULTS[sign.type] || {}), ...sign };
  const title = d.title || '';
  const content = d.content || '';

  switch (sign.type) {
    case 'numbering': {
      const rot = ARROW_ROT[d.arrowDirection] || 0;
      return `<div class="frame num">
        <div class="num-text">${esc(d.fromNumber)} – ${esc(d.toNumber)}</div>
        <div class="num-arrow" style="transform:rotate(${rot}deg)">${ICONS.arrow}</div>
      </div>`;
    }
    case 'agb': {
      // Hochformat, zweispaltig; "# " = Überschrift, Leerzeile = Absatzabstand
      const text = content || AGB_DEFAULT;
      let html = '';
      let first = true;
      for (const raw of text.split('\n')) {
        const l = raw.trim();
        if (!l) { html += '<div class="agb-gap"></div>'; continue; }
        if (l.startsWith('# ')) {
          html += `<div class="${first ? 'agb-h1' : 'agb-h2'}">${esc(l.slice(2))}</div>`;
          first = false;
          continue;
        }
        if (l.startsWith('> ')) { html += `<div class="agb-sub">${esc(l.slice(2))}</div>`; continue; }
        html += `<div class="agb-p">${esc(l)}</div>`;
      }
      return `<div class="agb-wrap">${html}</div>`;
    }
    case 'fire_hydrant':
      return '<div class="frame hydrant"><div class="hydrant-h">H</div></div>';
    case 'price_5euro':
      return `<div class="frame price">
        <div class="price-title">${esc(title)}</div>
        <div class="price-amount">5 €</div>
        <div class="price-detail">pro Tag · per day</div>${FOOT}
      </div>`;
    case 'liability_limit':
      return `<div class="frame liability">
        <div class="liab-icon">${ICONS.scales}</div>
        <div class="liab-text">Haftungsobergrenze</div>
        <div class="liab-amount">100 €</div>
        <div class="liab-sub">Liability limit per item</div>${FOOT}
      </div>`;
    case 'baggage_dropoff':
    case 'baggage_pickup': {
      const en = sign.type === 'baggage_dropoff' ? 'DROP-OFF' : 'PICK-UP';
      const de = sign.type === 'baggage_dropoff' ? 'GEPÄCKANNAHME' : 'GEPÄCKABHOLUNG';
      return `<div class="frame dir">
        <div class="dir-arrows">${ICONS.arrow}${ICONS.arrow}${ICONS.arrow}</div>
        <div class="dir-en">${en}</div>
        <div class="dir-de">${de}</div>
        <div class="dir-sub">${esc(content)}</div>
      </div>`;
    }
    case 'no_bike_parking': {
      // Zeile 1 des Inhalts ist im Titel schon enthalten – nur die Konsequenz drucken
      const lines = content.split('\n').filter((l) => l.trim());
      const sub = lines.length > 1 ? lines.slice(1).join('\n') : content;
      return `<div class="frame std">
        <div class="std-icon">${ICONS.bike_forbidden}</div>
        <div class="std-title">${esc(title)}</div>
        <div class="std-body">${paras(sub, 'line')}</div>
        <div class="std-en">No bicycle parking – bicycles will be removed at the owner's expense.</div>${FOOT}
      </div>`;
    }
    default: {
      const icon = ICONS[ICON_FOR[sign.type]] || '';
      return `<div class="frame std${icon ? '' : ' noicon'}">
        ${icon ? `<div class="std-icon">${icon}</div>` : ''}
        <div class="std-title">${esc(title)}</div>
        <div class="std-body">${paras(content, 'line')}</div>${FOOT}
      </div>`;
    }
  }
}

const CSS = `
@page { size: A4 landscape; margin: 0; }
@page hoch { size: A4 portrait; margin: 0; }
.sign-page.portrait { page: hoch; width: 210mm; height: 297mm; padding: 12mm 14mm; }
.agb-wrap { column-count: 2; column-gap: 8mm; column-fill: auto; height: 100%; font-size: 8.9pt; line-height: 1.28; color: #111; text-align: justify; hyphens: auto; }
.agb-h1 { column-span: all; font-size: 16pt; font-weight: 700; text-align: left; margin-bottom: 1mm; }
.agb-sub { column-span: all; font-size: 9pt; color: #555; text-align: left; margin-bottom: 3mm; padding-bottom: 2mm; border-bottom: 0.4mm solid #111; }
.agb-h2 { font-size: 10pt; font-weight: 700; margin-top: 2mm; margin-bottom: 0.8mm; text-align: left; break-after: avoid; }
.agb-p { margin-bottom: 1mm; }
.agb-gap { height: 1.2mm; }
* { margin: 0; padding: 0; box-sizing: border-box; }
html, body { background: #fff; font-family: Arial, Helvetica, "Liberation Sans", "DejaVu Sans", sans-serif; color: #111; }
.sign-page { width: 297mm; height: 210mm; padding: 10mm; overflow: hidden; break-after: page; page-break-after: always; }
.sign-page:last-child { break-after: auto; page-break-after: auto; }
.frame { width: 100%; height: 100%; border: 2.5mm solid #111; border-radius: 8mm; padding: 10mm 14mm;
         display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; position: relative; }
.ico { display: block; width: 100%; height: 100%; }
.foot { position: absolute; left: 0; right: 0; bottom: 5mm; font-size: 11pt; color: #888; letter-spacing: 0.08em; }
.gap { height: 5mm; }

/* Standardschild: Symbol + Titel + Text */
.std-icon { width: 58mm; height: 58mm; margin-bottom: 6mm; }
.std-title { font-size: 40pt; font-weight: 700; line-height: 1.1; letter-spacing: 0.01em; margin-bottom: 6mm; max-width: 250mm; }
.std-body .line { font-size: 21pt; color: #333; line-height: 1.3; max-width: 240mm; margin: 0 auto; }
.std-en { margin-top: 7mm; font-size: 15pt; color: #777; font-style: italic; }
.noicon .std-title { font-size: 48pt; }

/* Nummerierung */
.num-text { font-size: 120pt; font-weight: 700; line-height: 1; margin-bottom: 8mm; }
.num-arrow { width: 70mm; height: 70mm; }

/* Feuerwehr-Hydrant */
.hydrant { border-color: #d62828; }
.hydrant-h { font-size: 560pt; font-weight: 900; line-height: 0.9; color: #d62828; font-family: "Arial Black", Arial, "Liberation Sans", sans-serif; }

/* Preis */
.price-title { font-size: 34pt; font-weight: 700; margin-bottom: 4mm; }
.price-amount { font-size: 220pt; font-weight: 900; line-height: 0.95; }
.price-detail { font-size: 40pt; color: #444; margin-top: 2mm; }

/* Haftung */
.liab-icon { width: 40mm; height: 40mm; margin-bottom: 4mm; }
.liab-text { font-size: 60pt; font-weight: 700; line-height: 1; }
.liab-amount { font-size: 150pt; font-weight: 900; line-height: 1; margin: 4mm 0; }
.liab-sub { font-size: 22pt; color: #777; font-style: italic; }

/* Annahme / Abholung */
.dir-arrows { display: flex; gap: 12mm; margin-bottom: 4mm; }
.dir-arrows .ico { width: 34mm; height: 34mm; transform: rotate(180deg); }
.dir-en { font-size: 80pt; font-weight: 900; line-height: 1; }
.dir-de { font-size: 66pt; font-weight: 700; line-height: 1; margin-top: 6mm; }
.dir-sub { font-size: 24pt; color: #555; margin-top: 8mm; }
`;

export function buildSignageHtml(signs) {
  const pages = signs.map((s) =>
    `<div class="sign-page${s.type === 'agb' ? ' portrait' : ''}">${renderSign(s)}</div>`).join('');
  return `<!DOCTYPE html><html lang="de"><head><meta charset="UTF-8"><title>Beschilderung</title><style>${CSS}</style></head><body>${pages}</body></html>`;
}
